import { render, staticRenderFns } from "./tenantDispatcher.vue?vue&type=template&id=b9c9f76c&scoped=true&"
import script from "./tenantDispatcher.vue?vue&type=script&lang=js&"
export * from "./tenantDispatcher.vue?vue&type=script&lang=js&"
import style0 from "@/assets/style/modal.css?vue&type=style&index=0&id=b9c9f76c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c9f76c",
  null
  
)

export default component.exports